import { render } from "./PopupAddUserContract.vue?vue&type=template&id=3592fe36&scoped=true"
import script from "./PopupAddUserContract.vue?vue&type=script&lang=js"
export * from "./PopupAddUserContract.vue?vue&type=script&lang=js"

import "./PopupAddUserContract.vue?vue&type=style&index=0&id=3592fe36&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3592fe36"]])

export default __exports__